import RandingStyle1 from "../../randing/RandingStyle1";
import RandingStyle4 from "../../randing/RandingStyle4";

function Randing043({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle4
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/043/24123001.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/043/24123002.jpg`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/043/24123003.jpg`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/043/24123004.jpg`}
      benefitInfoPosition="bottom"
      formFieldColor="white"
      privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton2.png`}
      companyName="광교365리움치과병원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/gwanggyo.jpg`}
    />
  );
}

export default Randing043;
